<template>
  <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5892 3.57733C10.9147 3.90277 10.9147 4.4304 10.5892 4.75584L6.17849 9.16659H15.8333C16.2936 9.16659 16.6666 9.53968 16.6666 9.99992C16.6666 10.4602 16.2936 10.8333 15.8333 10.8333H6.17849L10.5892 15.244C10.9147 15.5694 10.9147 16.0971 10.5892 16.4225C10.2638 16.7479 9.73616 16.7479 9.41072 16.4225L3.57739 10.5892C3.25195 10.2637 3.25195 9.7361 3.57739 9.41066L9.41072 3.57733C9.73616 3.25189 10.2638 3.25189 10.5892 3.57733Z"
      fill="currentColor"
    />
  </svg>
</template>

<script setup></script>
